import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { Formik, Field, Form } from "formik";
import { TextField } from "formik-material-ui";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import axios from "axios";

import { routeMap } from "../routes/portalRoutes";
import {
  identifyUser,
  identifyCustomerIOPatientLogin,
} from "~/shared/utils/analytics";

import {
  setUserID,
  setFirstName,
  setLastName,
  setAPITokenJWT,
  setEmail,
  setPhone,
  setGender,
  clearCookies,
} from "../utils/portalCookies";

import {
  setVisitUSState,
  getUserAlreadyExists,
} from "~/visits/utils/visitCookies";

const initialValues = {
  email: getUserAlreadyExists(),
  password: "",
};

export default function PortalLogin(props) {
  const [loginError, setLoginError] = useState("");

  // Extract the error message from the location state, if available
  const location = useLocation();
  const errorMessage = location.state?.errorMessage || null;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required."),
    password: Yup.string().required("Password is required"),
  });

  return (
    <Grid
      container
      justifyContent="center"
      style={{
        backgroundColor: "#3f3f82",
      }}
    >
      <Grid
        item
        style={{ display: "flex", flexDirection: "column" }}
        md={8}
        xs={10}
      >
        <div
          style={{
            backgroundColor: "white",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "10px",
            padding: "20px",
            maxWidth: "100%",
            margin: "40px 0",
          }}
        >
          <Typography
            style={{
              fontFamily: "BasisGrotesquePro-Bold",
              // fontWeight: "bold",
              fontSize: "24px",
              textAlign: "center",
              margin: "30px 0 20px 0",
            }}
          >
            Welcome Back
          </Typography>
          <Formik
            validationSchema={validationSchema}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              const { email, password } = values;

              axios
                .post("/me/login/", {
                  email: email,
                  password: password,
                })
                .then((response) => {
                  setSubmitting(false);
                  // console.log("RESPONSE:", response);
                  const jsonData = response.data.data;
                  // console.log("jsonData:", jsonData);

                  const {
                    apiTokenJWT,
                    firstName,
                    lastName,
                    phone,
                    gender,
                    email,
                    usState,
                  } = jsonData.attributes;

                  clearCookies();

                  setUserID(jsonData.id);
                  setAPITokenJWT(apiTokenJWT);
                  setEmail(email);
                  setPhone(phone);
                  setGender(gender);
                  setFirstName(firstName);
                  setLastName(lastName);
                  setVisitUSState(usState);

                  if (jsonData.id) {
                    identifyUser(jsonData.id);
                    identifyCustomerIOPatientLogin(email);
                  }

                  // reinit fb pixel for advanced matching
                  // fbqReInit();

                  if (apiTokenJWT) {
                    // redirect to where we came from, or to "/me/portal"
                    let { from } = props.location.state || {
                      from: { pathname: routeMap.patientPortalIndex },
                    };
                    props.history.push(from);
                  } else {
                    console.error("Error: Invalid Login Token received");
                  }
                })
                .catch((error) => {
                  setSubmitting(false);

                  if (error.response) {
                    console.error("Error logging in:", error.response);
                    setLoginError(error.response.data.errors[0].title);
                  } else {
                    console.log("Error logging in:", error);
                  }
                });
            }}
            render={({ submitForm, isSubmitting, values, setFieldValue }) => (
              <Form
                style={{
                  display: "flex",
                  width: "100%",
                  maxWidth: "300px",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "0 auto 30px",
                }}
              >
                <Field
                  component={TextField}
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={TextField}
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  variant="outlined"
                  style={{ marginTop: "16px" }}
                  fullWidth
                  onKeyPress={(ev) => {
                    if (ev.key === "Enter") {
                      submitForm();
                    }
                  }}
                />
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    color: "red",
                  }}
                >
                  <p>{loginError || errorMessage}</p>
                </div>
                <Button
                  disabled={isSubmitting}
                  type="submit"
                  onClick={submitForm}
                  color="primary"
                  size="large"
                  style={{
                    backgroundColor: "#f25930",
                    color: "white",
                    marginTop: "10px",
                    justifySelf: "center",
                    alignSelf: "center",
                    width: "100%",
                  }}
                >
                  Login
                </Button>
                <div style={{ marginTop: "6px", marginBottom: "6px" }}>
                  <a href="/me/password-reset" style={{ fontSize: "15px" }}>
                    Forgot your password? Reset it here.
                  </a>
                </div>
                — OR —
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Button
                    disabled={isSubmitting}
                    onClick={() => {
                      window.location.href = "/me/login-send-sms";
                    }}
                    color="primary"
                    size="large"
                    style={{
                      backgroundColor: "#3f3f82",
                      color: "#fff2f0",
                      justifySelf: "center",
                      alignSelf: "center",
                      width: "100%",
                      margin: "10px 6px 0",
                    }}
                  >
                    Text me a login link
                  </Button>
                  <Button
                    disabled={isSubmitting}
                    onClick={() => {
                      window.location.href = "/me/login-send-email";
                    }}
                    color="primary"
                    size="large"
                    style={{
                      backgroundColor: "#3f3f82",
                      color: "#fff2f0",
                      justifySelf: "center",
                      alignSelf: "center",
                      width: "100%",
                      margin: "10px 6px 0",
                    }}
                  >
                    Email me a login link
                  </Button>
                </div>
              </Form>
            )}
          />
        </div>
      </Grid>
    </Grid>
  );
}
